/* ============================================================
   SAINT GRAAL · email capture resilience
   Added 2026-09-11 after the homepage waitlist was found to fail
   silently: clicking Join the List produced no navigation, no
   success message and no error. Nothing at all.

   Cause: Shopify injects an invisible hCaptcha into every
   {% form 'customer' %} and gates the submit on it. When the
   captcha does not clear, and the most common reason is a content
   blocker stopping hcaptcha.com from loading, the POST never
   happens and the stock theme has nothing to say about it.

   This does not defeat the captcha. It makes the failure visible,
   which is the actual defect. Three email capture points share the
   behaviour: the homepage waitlist, the Reserve control on each
   product, and the form on the newsletter page.
   ============================================================ */
(function () {
  'use strict';

  var WAIT_MS = 9000; // how long a submit may hang before we call it

  var CONFIG = (function () {
    var el = document.getElementById('sg-forms-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  function isCustomerForm(form) {
    var t = form.querySelector('input[name="form_type"]');
    return !!t && t.value === 'customer';
  }

  function expectsCaptcha(form) {
    return !!form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
  }

  // The vendor script never arrived, so the invisible check can never resolve.
  function captchaBlocked() {
    return !window.hcaptcha && !window.grecaptcha;
  }

  // A visible challenge is on screen and the visitor still has work to do.
  function challengeOpen() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha.com"], iframe[src*="recaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var r = f.getBoundingClientRect();
      if (r.width > 80 && r.height > 80 && window.getComputedStyle(f).display !== 'none') return true;
    }
    return false;
  }

  function helpHtml() {
    if (CONFIG.supportEmail) {
      return 'If it keeps happening, write to <a href="mailto:' + CONFIG.supportEmail + '">' +
             CONFIG.supportEmail + '</a> and we will add you by hand.';
    }
    return 'If it keeps happening, <a href="/pages/contact">send us a note</a> and we will add you by hand.';
  }

  // Reuse the section's own message element where the theme has one, so the
  // styling stays local. Otherwise make one and put it after the field row.
  function messageEl(form) {
    var existing = form.querySelector('.waitlist-msg, .reserve-msg, .sg-form-alert');
    if (existing && existing.classList.contains('sg-form-alert')) return existing;

    var el = document.createElement('p');
    el.className = 'sg-form-alert';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var note = form.querySelector('.waitlist-note, .reserve-note');
    if (note && note.parentNode) note.parentNode.insertBefore(el, note);
    else form.appendChild(el);
    return el;
  }

  function show(form, html, isError) {
    var el = messageEl(form);
    el.innerHTML = html;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-shown');
    var note = form.querySelector('.waitlist-note, .reserve-note');
    if (note) note.hidden = true;
  }

  function clear(form) {
    var el = form.querySelector('.sg-form-alert');
    if (el) { el.classList.remove('is-shown', 'is-error'); el.innerHTML = ''; }
    var note = form.querySelector('.waitlist-note, .reserve-note');
    if (note) note.hidden = false;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      if (!btn.dataset.sgLabel) btn.dataset.sgLabel = btn.textContent;
      btn.textContent = btn.dataset.sgBusy || 'One moment';
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      if (btn.dataset.sgLabel) btn.textContent = btn.dataset.sgLabel;
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function wire(form) {
    if (form.dataset.sgWired) return;
    form.dataset.sgWired = '1';

    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      clear(form);
      setBusy(btn, true);

      // The page is expected to navigate. Everything below only ever runs
      // because it did not.
      var started = Date.now();
      var sawChallenge = false;

      var tick = window.setInterval(function () {
        if (challengeOpen()) {
          sawChallenge = true;
          show(form, 'Finish the check to complete your signup.', false);
          started = Date.now(); // their clock, not ours
          return;
        }

        if (Date.now() - started < WAIT_MS) return;
        window.clearInterval(tick);
        setBusy(btn, false);

        if (expectsCaptcha(form) && captchaBlocked()) {
          show(form,
            'The spam check could not load, so your address was not sent. ' +
            'A content blocker or privacy extension is the usual reason. ' +
            'Allow it for this page, or try another browser, and it will go through. ' +
            helpHtml(), true);
        } else if (sawChallenge) {
          show(form, 'The check was not completed, so your address was not sent. ' +
                     'Please try once more. ' + helpHtml(), true);
        } else {
          show(form, 'That did not go through. Please try again. ' + helpHtml(), true);
        }
      }, 500);

      // If the page does navigate, none of this matters.
      window.addEventListener('pagehide', function () { window.clearInterval(tick); }, { once: true });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action^="/contact"]');
    for (var i = 0; i < forms.length; i++) {
      if (isCustomerForm(forms[i])) wire(forms[i]);
    }

    // After a real post Shopify reloads the page, and on a long page the
    // confirmation can land well below the fold where nobody sees it.
    var posted = document.querySelector('.waitlist-msg-ok, .waitlist-msg-error, .reserve-msg-ok, .reserve-msg-error');
    if (posted) {
      window.setTimeout(function () {
        posted.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
